// extracted by mini-css-extract-plugin
module.exports = {"Loader":"SmallSpinnerLight_Loader__2WBKD","load7":"SmallSpinnerLight_load7__13Q7x"};